export default function FsmLogo({ size = 16 }) {
  return (
    <span
      data-testid="fsm-logo"
      className="flex items-center justify-center font-black text-white leading-none"
      style={{ fontSize: size * 0.55, letterSpacing: "0.05em", fontFamily: "'Archivo Black', 'Arial Black', sans-serif" }}
    >
      FS
    </span>
  );
}
